import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";

// POST /api/admin/resource-persons — body: { name, email, phone, bio }
const AddResourcePersonModal = ({
  isOpen,
  onClose,
  onSubmit,
  isLoading,
  error,
  formData,
  onFormChange,
}) => {
  if (!isOpen) return null;

  const inputClass = "form-control";

  return (
    <div
      className="modal"
      style={{
        display: "flex",
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 1050,
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
      }}
    >
      <div
        className="modal-content"
        style={{
          backgroundColor: "#fff",
          borderRadius: "8px",
          padding: "24px",
          maxHeight: "90vh",
          overflowY: "auto",
          width: "min(90vw, 480px)",
        }}
      >
        <h5>Add Resource Person</h5>
        <form onSubmit={onSubmit}>
          {error !== "" ? (
            <div className="formErrorDiv">
              <FontAwesomeIcon icon={faInfoCircle} />
              <p className="formError">{error}</p>
            </div>
          ) : null}
          <div className="form-group">
            <label>Full Name</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={onFormChange}
              className={inputClass}
              placeholder="e.g. Chinwe Agu"
              required
            />
          </div>
          <div className="form-group">
            <label>Email</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              className={inputClass}
              onChange={onFormChange}
              placeholder="e.g. chinwe@example.com"
              required
            />
          </div>
          <div className="form-group">
            <label>Phone</label>
            <input
              type="text"
              name="phone"
              value={formData.phone}
              onChange={onFormChange}
              className={inputClass}
              placeholder="e.g. +2348023456789"
            />
          </div>
          <div className="form-group">
            <label>Bio</label>
            <textarea
              name="bio"
              value={formData.bio}
              onChange={onFormChange}
              className={inputClass}
              rows={3}
              placeholder="e.g. Experienced mathematics educator with 10 years of teaching experience"
            />
          </div>
          <div className="modal-buttons">
            <button type="submit" className="btn btn-theme" disabled={isLoading}>
              {isLoading ? (
                <div className="spinner-border text-light btnspinner" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              ) : (
                "Add Resource Person"
              )}
            </button>
            <button
              type="button"
              className="btn btn-secondary"
              onClick={onClose}
              disabled={isLoading}
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddResourcePersonModal;